
<div class="loads" *ngIf="loader && !objQuestion" ></div>
<div class="incomeContainer mainCol" >
    <ng-container *ngIf="objQuestion">
        <div class="form-group">
        <label for="inputIncome">
            <h2 id="incomeLabel" *ngIf="applicantName">{{
                'identity.titleTextBox' | translate:{'applicantName':applicantName } }}</h2>
        </label>
        <div class="row margins minHtDivTip">
            <ng-container  >
        
            <p class="mt-md-3 mt-3 pb-0 mb-0 tip-fonts home-on-my-own-center">
              <span>{{ 'identity.infoLabel'  | translate }} </span>   
                </p>
                </ng-container>
        </div>
        <ng-container *ngFor="let singleQues of objQuestion.question; let i = index">
            <div class="row col-xs-12 col-sm-12">
                <small class="form-text col-xs-12 col-sm-12 displayFlex p-0 m-0 pb-1">
                    <label for="singleQues{{singleQues.questionId}}">{{ singleQues.questionText}}</label>
                </small>
    
            </div>
            <div [ngClass]="isIos ? 'select-wrapper col-12 p-0 m-0':'col-12 p-0 m-0'">

            <select class="col-xs-12 col-sm-12 col-md-12 p-0 m-0" (change)="fnFunctionChange(singleQues.questionId)" (focusout)="fnFocusOut($event,singleQues.questionId)" tabindex="0"
                style="height:45px" id="singleQues{{singleQues.questionId}}" [attr.aria-describedby]="'singleQuesk'+singleQues.questionId"
                aria-required="true">
             <option selected value=""></option>
                <option *ngFor="let ansObj of singleQues.answerChoice; let i = index" value="{{ansObj.answerId}}">{{ansObj.value}}</option>
            </select>
        </div>
            <small  id="singleQuesk{{singleQues.questionId}}" *ngIf="validDD[singleQues.questionId]"  class="form-text col-xs-12 col-sm-12 displayFlex  p-0 m-0 pb-1 errorMsg" >
                * {{'identity.validation' | translate }}
            </small>
            <br /><br />
        </ng-container>

     
    </div>


    <div class="row d-flex btnSave buttonMargin buttonsView">
        <button type="button" *ngIf="!disableContinue"   class="mobile-view-btn buttonCommon saveNextBtn  mt-md-5"
            (click)="onContinue()" aria-label="Continue">{{
            'buttonallpages.continuelable' | translate }}</button>
            <button type="button" *ngIf="disableContinue"   class="mobile-view-btn buttonCommon saveNextBtn  mt-md-5 lessOpacity"
             aria-label="Continue">{{
            'buttonallpages.continuelable' | translate }}</button>
        <cancel-button class="cnc-fll cancelMargin"></cancel-button>
        <button aria-label="Continue" type="button" *ngIf="!disableContinue"  class=" desktop-view-btn buttonCommon saveNextBtn ml-md-3 "
            (click)="onContinue()">{{
            'buttonallpages.continuelable' | translate }}</button>
            <button aria-label="Continue" type="button" *ngIf="disableContinue"    class="desktop-view-btn buttonCommon saveNextBtn ml-md-3 lessOpacity"
           >{{
            'buttonallpages.continuelable' | translate }}</button>
    </div>
</ng-container>
</div>